import * as React from 'react';
import EasyCropper from 'react-easy-crop';
import { Slider } from '../Slider';
import { calcCropInfo, calcAreaFromSource } from './cropper.utils';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export const Cropper = _ref => {
  let {
    sourceImage,
    onCropped,
    ratio,
    imageUrl,
    maxZoom = 5,
    initialCroppedAreaPixels
  } = _ref;
  const [crop, setCrop] = React.useState({
    x: 0,
    y: 0
  });
  const [zoom, setZoom] = React.useState(1);
  const [initialCropped, setIntitalCropped] = React.useState(initialCroppedAreaPixels);
  const onMediaLoaded = React.useCallback(mediaSize => {
    if (sourceImage) {
      const crop = calcAreaFromSource(sourceImage, mediaSize);
      setIntitalCropped(crop);
    }
  }, []);
  const onCropComplete = React.useCallback((croppedArea, croppedAreaPixels) => {
    if (onCropped) {
      onCropped(calcCropInfo(croppedArea, croppedAreaPixels, sourceImage));
    }
  }, []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(EasyCropper, {
      image: imageUrl,
      crop: crop,
      zoom: zoom,
      aspect: ratio,
      onCropChange: setCrop,
      onCropComplete: onCropComplete,
      onZoomChange: setZoom,
      maxZoom: maxZoom,
      onMediaLoaded: onMediaLoaded,
      initialCroppedAreaPixels: initialCropped
    }), /*#__PURE__*/_jsx("div", {
      style: {
        position: 'absolute',
        bottom: 0,
        left: '50%',
        width: '50%',
        transform: 'translateX(-50%)',
        display: 'flex'
      },
      children: /*#__PURE__*/_jsx(Slider, {
        styles: {
          root: {
            width: '100%'
          }
        },
        max: maxZoom * 100,
        min: 100,
        value: zoom * 100,
        onChange: value => {
          setZoom(value / 100);
        },
        showValue: false
      })
    })]
  });
};